import { ECustomDataPackageType } from '../../slices/customDataSlice';
import { TAppState } from '../../types';

export const selectCustomDataPackageType = (state: TAppState): ECustomDataPackageType | null => {
  return state.custom.packageType;
};
